// @core/api/endpoints/userprofile/list_banners.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListBannersResponse,
} from '../../../types/userprofile';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/userprofile';

/**
 * List banners for profile
 * Returns all banners associated with a profile, including both active and inactive ones. Only the profile owner can list their banners.
 */
export async function ListBanners(
  profile_id: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListBannersResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:profile_id/banners`;
  requestPath = requestPath.replace(':profile_id', encodeURIComponent(profile_id));
  const requestOptions = options;
  return client.get<ListBannersResponse>(requestPath, { ...requestOptions, params });
}
